<script setup lang="ts">
withDefaults(
  defineProps<{
    pagination?: boolean
    navigation?: boolean
  }>(),
  {
    pagination: true,
    navigation: true,
  },
)
</script>

<template>
  <div class="flex items-center justify-center">
    <div v-show="navigation" class="swiper--prev z-fixed cursor-pointer">
      <BaseIcon class="!block" name="navArrowLeft" />
    </div>

    <div v-if="pagination" class="swiper-pagination pagination-v2" />

    <div v-show="navigation" class="swiper--next z-fixed cursor-pointer">
      <BaseIcon class="!block" name="navArrowRight" />
    </div>
  </div>
</template>

<style>
.swiper-pagination.pagination-v2 {
  @apply static flex items-center !w-auto mx-6;
}

.swiper-pagination.pagination-v2 .swiper-pagination-bullet {
  @apply w-[5px] h-[5px] border border-gray-600;
}

.swiper-pagination.pagination-v2 .swiper-pagination-bullet-active {
  @apply bg-gray-600 w-[8px] h-[8px] border-0;
}
</style>
